import { ObjectDirective } from "vue"

const directive: ObjectDirective = {
    inserted(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // Check if the element or one of its children was clicked
            if (el === event.target || el.contains(event.target)) {
                // If the element or one of its children was clicked, do nothing
                return;
            }
            // Otherwise, execute the binding
            vnode.context[binding.expression](event);
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
};

export default directive;